import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'feature-loading-navbar-skeleton',
    templateUrl: './navbar-skeleton.component.html',
    styleUrls: ['./navbar-skeleton.component.css'],
    standalone: false
})
export class NavbarSkeletonComponent implements OnInit {
  navbarItems = 7;

  constructor() {}

  ngOnInit(): void {}
}
